import { Link } from 'react-router-dom'
import { SolutionsDropdown } from './SolutionsDropdown'

/**
 * Shared header for every marketing route except Landing (which keeps
 * its scroll-aware sticky header inline because that behaviour is
 * specific to the homepage).
 *
 * Detail pages (/solutions/<slug>, /blog/<slug>, /case-studies/<slug>,
 * etc.) previously shipped near-empty headers with just the logo and a
 * Start-for-Free CTA — no way to navigate to other marketing sections
 * without going back. This component fixes that and threads the
 * Solutions dropdown through every page in one place.
 */
export function MarketingHeader() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src="/algoscale-logo.png"
              alt="Algoscale company logo"
              width="172"
              height="49"
              decoding="async"
              className="h-8 w-auto"
            />
            <span className="text-lg font-semibold tracking-tight text-gray-900">
              DocumentIQ
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <SolutionsDropdown />
            <Link
              to="/case-studies"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              Case Studies
            </Link>
            <Link
              to="/blog"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              Blog
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="hidden sm:block text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm"
            >
              Start for Free
            </Link>
          </div>
        </div>
      </div>
    </header>
  )
}
